import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Domingo preparando planeamiento desde cero porque no hay plantillas que realmente sirvan para el MEP', 'Mensajes de padres difíciles que llegan a las 9 de la noche y arruinan el descanso', 'Grupos imposibles sin ningún protocolo claro para recuperar el orden', 'Cuatro comités activos, ninguno con documentos al día', 'Cansancio que ya no se va con el fin de semana', 'El mismo ciclo de agotamiento, domingo tras domingo, año tras año'];
  return <section className="py-20 px-4 bg-white" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-230">
            ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
          </h2>
          <p className="text-lg text-stone-600 mb-8 leading-relaxed" data-id="element-231">
            Sos docente del MEP. Amás lo que hacés. Pero nadie te dijo que ibas
            a pasar los domingos con un nudo en el pecho, preparando materiales
            que no terminan, respondiendo mensajes de padres y llegando al lunes
            completamente drenado/a antes de que la semana empiece.
          </p>

          <div className="bg-red-50 border border-red-100 rounded-xl p-6 inline-block mx-auto mb-10" data-id="element-232">
            <p className="text-xl font-bold text-red-800 mb-2" data-id="element-233">
              No es falta de vocación.
            </p>
            <p className="text-2xl font-black text-red-900" data-id="element-234">
              Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-235">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3 p-4 rounded-lg hover:bg-stone-50 transition-colors" data-id="element-236">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-237" />
              <p className="text-stone-700 font-medium" data-id="element-238">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-239">
          <p className="text-2xl md:text-3xl font-bold text-brand-700" data-id="element-240">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}